(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gummy-collection-2011"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-gummy-filter]');
    if (!button) return;
    var group = button.parentElement;
    var filter = button.dataset.gummyFilter;
    var grid = group.parentElement.querySelector('[data-gummy-collection-grid]');
    if (!grid) return;

    group.querySelectorAll('[data-gummy-filter]').forEach(function(b) {
      b.classList.toggle('is-active', b === button);
    });

    grid.querySelectorAll('.gummy-collection-2011__card').forEach(function(card) {
      var matches = filter === 'all' || card.dataset.gummyColor === filter;
      card.hidden = !matches;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gummy-product-2011"] && !Shopify.designMode) return;
  try {
    
  var GUMMY_ICON_SVGS = {
    Heart: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7-4.5-9.5-9.1C.7 8.4 2.6 4 6.3 4c2 0 3.6 1 4.7 2.6C12.1 5 13.7 4 15.7 4c3.7 0 5.6 4.4 3.8 7.9C19 16.5 12 21 12 21z"/></svg>',
    Star: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.5 7.1.8-5.3 4.8 1.5 7-6.2-3.5L5.8 21l1.5-7L2 9.3l7.1-.8L12 2z"/></svg>',
    Lightning: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L4 14h6l-2 8 10-12h-6l1-8z"/></svg>',
    Smiley: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><circle cx="9" cy="10" r="0.9" fill="currentColor"/><circle cx="15" cy="10" r="0.9" fill="currentColor"/><path d="M8 14.5c1.2 1.4 2.6 2 4 2s2.8-.6 4-2" stroke-linecap="round"/></svg>',
    Flower: '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="2.4"/><circle cx="12" cy="5.5" r="3"/><circle cx="12" cy="18.5" r="3"/><circle cx="5.5" cy="12" r="3"/><circle cx="18.5" cy="12" r="3"/></svg>'
  };

  function gummyRenderPreview(form) {
    if (!form) return;
    var section = form.closest('[data-gummy-product-section]');
    var overlay = section && section.querySelector('[data-gummy-preview-overlay]');
    if (!overlay) return;

    var designChoice = form.querySelector('[data-gummy-design-choice]');
    var textInput = form.querySelector('[data-gummy-custom-text]');
    var iconRadios = form.querySelectorAll('[data-gummy-icon-choice]:checked');
    var selectedOption = designChoice ? designChoice.options[designChoice.selectedIndex] : null;
    var needsText = selectedOption && selectedOption.dataset.gummyNeedsText === 'true';
    var needsIcon = selectedOption && selectedOption.dataset.gummyNeedsIcon === 'true';
    var hasCustom = needsText || needsIcon;

    if (!hasCustom) {
      overlay.innerHTML = '';
      overlay.classList.remove('is-active');
      return;
    }

    var html = '';
    if (needsIcon && iconRadios.length) {
      var icon = iconRadios[0].value;
      if (GUMMY_ICON_SVGS[icon]) {
        html += '<span class="gummy-product-2011__media-overlay-icon">' + GUMMY_ICON_SVGS[icon] + '</span>';
      }
    }
    if (needsText && textInput && textInput.value) {
      var lines = textInput.value.split('\n').map(function(line) {
        return line.replace(/[&<>"']/g, function(c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      });
      html += '<span class="gummy-product-2011__media-overlay-text">' + lines.join('<br>') + '</span>';
    }
    overlay.innerHTML = html;
    overlay.classList.toggle('is-active', html !== '');
  }

  function syncGummyCustomizer(form) {
    if (!form) return;

    var designChoice = form.querySelector('[data-gummy-design-choice]');
    var textField = form.querySelector('[data-gummy-text-field]');
    var textInput = form.querySelector('[data-gummy-custom-text]');
    var iconField = form.querySelector('[data-gummy-icon-field]');
    var iconSelect = form.querySelector('[data-gummy-icon-choice]');
    var selectedOption = designChoice ? designChoice.options[designChoice.selectedIndex] : null;
    var needsText = selectedOption && selectedOption.dataset.gummyNeedsText === 'true';
    var needsIcon = selectedOption && selectedOption.dataset.gummyNeedsIcon === 'true';

    if (textField) textField.hidden = !needsText;
    if (textInput) {
      textInput.required = !!needsText;
      textInput.disabled = !needsText || designChoice.disabled;
      textInput.setCustomValidity('');
      if (!needsText) textInput.value = '';
    }

    if (iconField) iconField.hidden = !needsIcon;
    var iconRadios = form.querySelectorAll('[data-gummy-icon-choice]');
    iconRadios.forEach(function(radio) {
      radio.required = !!needsIcon;
      radio.disabled = !needsIcon || designChoice.disabled;
      if (!needsIcon) radio.checked = false;
    });

    var counter = form.querySelector('[data-gummy-text-counter]');
    if (counter && textInput) {
      counter.textContent = (textInput.value.length || 0) + '/' + (textInput.getAttribute('maxlength') || '32');
    }

    var isCustom = needsText || needsIcon;
    var customOrder = form.querySelector('[data-gummy-custom-order]');
    var customVersion = form.querySelector('[data-gummy-custom-version]');
    if (customOrder) customOrder.disabled = !isCustom;
    if (customVersion) customVersion.disabled = !isCustom;

    gummyRenderPreview(form);
  }

  document.addEventListener('input', function(event) {
    var textInput = event.target.closest('[data-gummy-custom-text]');
    if (!textInput) return;
    var form = textInput.closest('.gummy-product-2011__form');
    if (!form) return;
    var counter = form.querySelector('[data-gummy-text-counter]');
    if (counter) {
      counter.textContent = textInput.value.length + '/' + (textInput.getAttribute('maxlength') || '32');
    }
    gummyRenderPreview(form);
  });

  document.addEventListener('change', function(event) {
    var icon = event.target.closest('[data-gummy-icon-choice]');
    if (!icon) return;
    var form = icon.closest('.gummy-product-2011__form');
    if (form) gummyRenderPreview(form);
  });

  document.addEventListener('change', function(event) {
    var designChoice = event.target.closest('[data-gummy-design-choice]');
    if (designChoice) {
      designChoice.setCustomValidity('');
      syncGummyCustomizer(designChoice.closest('.gummy-product-2011__form'));
      return;
    }

    var select = event.target.closest('[data-gummy-variant-select]');
    if (!select) return;

    var section = select.closest('[data-gummy-product-section]');
    if (!section) return;

    var option = select.options[select.selectedIndex];
    var price = section.querySelector('[data-gummy-price]');
    var title = section.querySelector('[data-gummy-variant-title]');
    var image = section.querySelector('[data-gummy-main-image]');
    var stockDisplay = section.querySelector('[data-gummy-stock-display]');
    var customizeButton = section.querySelector('[data-gummy-customize-open]');

    if (price && option.dataset.gummyPrice) price.textContent = option.dataset.gummyPrice;
    if (title && option.dataset.gummyTitle) title.textContent = option.dataset.gummyTitle;
    if (stockDisplay && option.dataset.gummyStock) stockDisplay.textContent = option.dataset.gummyStock;
    if (image && option.dataset.gummyImageSrc) {
      image.src = option.dataset.gummyImageSrc;
      image.removeAttribute('srcset');
    }
    if (customizeButton) {
      customizeButton.disabled = option.disabled;
      customizeButton.textContent = option.disabled ? 'sold out' : 'customize';
    }
    var stickyPrice = section.querySelector('[data-gummy-sticky-price]');
    if (stickyPrice && option.dataset.gummyPrice) stickyPrice.textContent = option.dataset.gummyPrice;
    var stickyButton = section.querySelector('[data-gummy-sticky-open]');
    if (stickyButton) {
      stickyButton.disabled = option.disabled;
      stickyButton.textContent = option.disabled ? 'sold out' : 'customize';
    }
    var activeColor = option.dataset.gummyTitle ? option.dataset.gummyTitle.split('/')[0].trim().toLowerCase() : '';
    section.querySelectorAll('[data-gummy-variant-swatch]').forEach(function(node) {
      node.classList.toggle('is-active', node.dataset.gummyColorKey === activeColor);
    });
  });

  document.addEventListener('click', function(event) {
    var stickyOpen = event.target.closest('[data-gummy-sticky-open]');
    if (stickyOpen) {
      var sectionEl = stickyOpen.closest('[data-gummy-product-section]');
      var mainOpen = sectionEl && sectionEl.querySelector('[data-gummy-customize-open]');
      if (mainOpen && !mainOpen.disabled) {
        mainOpen.click();
        mainOpen.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    var openButton = event.target.closest('[data-gummy-customize-open]');
    if (openButton) {
      var openForm = openButton.closest('.gummy-product-2011__form');
      if (!openForm) return;

      var openPanel = openForm.querySelector('[data-gummy-customizer]');
      var openFields = openForm.querySelectorAll('[data-gummy-custom-required]');
      if (!openPanel) return;

      openPanel.hidden = false;
      var openSection = openForm.closest('[data-gummy-product-section]');
      var openScrim = openSection && openSection.querySelector('[data-gummy-customizer-scrim]');
      if (openScrim) openScrim.hidden = false;
      document.body.classList.add('gummy-customizer-open');
      openButton.setAttribute('aria-expanded', 'true');
      openFields.forEach(function(field) {
        field.disabled = true;
      });

      var designChoice = openForm.querySelector('[data-gummy-design-choice]');
      if (designChoice) designChoice.disabled = false;
      syncGummyCustomizer(openForm);

      if (designChoice) {
        designChoice.focus();
      } else {
        var firstField = openFields[0];
        if (firstField) firstField.focus();
      }
      return;
    }

    var closeButton = event.target.closest('[data-gummy-customize-close]');
    if (closeButton) {
      var closeSection = closeButton.closest('[data-gummy-product-section]');
      if (!closeSection) return;
      var closeForm = closeSection.querySelector('.gummy-product-2011__form');
      if (!closeForm) return;

      var closePanel = closeForm.querySelector('[data-gummy-customizer]');
      var trigger = closeForm.querySelector('[data-gummy-customize-open]');
      var closeFields = closeForm.querySelectorAll('[data-gummy-custom-required]');
      var closeScrim = closeSection.querySelector('[data-gummy-customizer-scrim]');

      if (closePanel) closePanel.hidden = true;
      if (closeScrim) closeScrim.hidden = true;
      document.body.classList.remove('gummy-customizer-open');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
      closeFields.forEach(function(field) {
        field.disabled = true;
        field.required = field.matches('[data-gummy-design-choice]');
        field.setCustomValidity('');
      });
      syncGummyCustomizer(closeForm);
      return;
    }

    var variantSwatch = event.target.closest('[data-gummy-variant-swatch]');
    if (variantSwatch) {
      var swatchSection = variantSwatch.closest('[data-gummy-product-section]');
      if (!swatchSection) return;

      var variantSelect = swatchSection.querySelector('[data-gummy-variant-select]');
      var targetColor = variantSwatch.dataset.gummyColorKey;
      if (variantSelect && targetColor) {
        var currentOption = variantSelect.options[variantSelect.selectedIndex];
        var currentParts = currentOption && currentOption.dataset.gummyTitle ? currentOption.dataset.gummyTitle.split('/') : [];
        var currentSize = currentParts.length > 1 ? currentParts[1].trim().toLowerCase() : '';
        var match = null;
        var firstColorMatch = null;
        for (var i = 0; i < variantSelect.options.length; i++) {
          var opt = variantSelect.options[i];
          if (!opt.dataset.gummyTitle) continue;
          var parts = opt.dataset.gummyTitle.split('/');
          var color = parts[0].trim().toLowerCase();
          var size = parts.length > 1 ? parts[1].trim().toLowerCase() : '';
          if (color !== targetColor) continue;
          if (!firstColorMatch) firstColorMatch = opt;
          if (size === currentSize && !opt.disabled) { match = opt; break; }
        }
        var chosen = match || firstColorMatch;
        if (chosen) {
          variantSelect.value = chosen.value;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      return;
    }

    var thumb = event.target.closest('[data-gummy-thumb]');
    if (!thumb) return;

    var section = thumb.closest('[data-gummy-product-section]');
    if (!section) return;

    var image = section.querySelector('[data-gummy-main-image]');
    if (image && thumb.dataset.gummyImageSrc) {
      image.src = thumb.dataset.gummyImageSrc;
      image.removeAttribute('srcset');
    }

    section.querySelectorAll('[data-gummy-thumb]').forEach(function(node) {
      node.classList.toggle('is-active', node === thumb);
    });
  });

  document.addEventListener('input', function(event) {
    var field = event.target.closest('[data-gummy-custom-required]');
    if (!field) return;

    field.setCustomValidity('');
  });

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('.gummy-product-2011__form');
    if (!form) return;

    var customizer = form.querySelector('[data-gummy-customizer]');
    var trigger = form.querySelector('[data-gummy-customize-open]');
    var fields = form.querySelectorAll('[data-gummy-custom-required]');

    if (customizer && customizer.hidden) {
      event.preventDefault();
      customizer.hidden = false;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      fields.forEach(function(field) {
        field.disabled = true;
      });
      var designChoice = form.querySelector('[data-gummy-design-choice]');
      if (designChoice) designChoice.disabled = false;
      syncGummyCustomizer(form);
    }

    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (field.disabled) continue;
      if (field.value.trim() !== '') {
        field.setCustomValidity('');
        continue;
      }

      event.preventDefault();
      if (customizer) customizer.hidden = false;

      if (field.name === 'properties[Design choice]') {
        field.setCustomValidity('choose one design style for this band.');
      } else if (field.name === 'properties[Custom text]') {
        field.setCustomValidity('enter the exact text you want on the band.');
      } else if (field.name === 'properties[Icon choice]') {
        field.setCustomValidity('choose the icon for this band.');
      } else {
        field.setCustomValidity('complete this custom order field.');
      }

      field.reportValidity();
      field.focus();
      break;
    }
  });

  function gummyFormatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function gummyRenderCartDrawer(cart) {
    var drawer = document.querySelector('[data-gummy-cart-drawer]');
    if (!drawer) return;
    var body = drawer.querySelector('[data-gummy-cart-body]');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="gummy-cart-drawer__empty">cart is empty.</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function(item) {
      var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
      html += '<div class="gummy-cart-drawer__item">' + img +
        '<div class="gummy-cart-drawer__item-info">' +
          '<p>' + item.product_title + '</p>' +
          '<small>' + (item.variant_title || '') + ' · qty ' + item.quantity + '</small>' +
          '<p>' + gummyFormatMoney(item.final_line_price) + '</p>' +
        '</div></div>';
    });
    html += '<div class="gummy-cart-drawer__totals"><p>subtotal: ' + gummyFormatMoney(cart.total_price) + '</p></div>';
    body.innerHTML = html;
  }

  function gummyOpenCartDrawer() {
    var drawer = document.querySelector('[data-gummy-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function() { drawer.classList.add('is-open'); });
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(gummyRenderCartDrawer)
      .catch(function() {});
  }

  function gummyCloseCartDrawer() {
    var drawer = document.querySelector('[data-gummy-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(function() { drawer.hidden = true; }, 180);
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-gummy-cart-close]')) {
      gummyCloseCartDrawer();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    gummyCloseCartDrawer();
    var openCustomizer = document.querySelector('.gummy-product-2011__customizer:not([hidden])');
    if (openCustomizer) {
      var openSection = openCustomizer.closest('[data-gummy-product-section]');
      var closeBtn = openSection && openSection.querySelector('[data-gummy-customize-close]');
      if (closeBtn) closeBtn.click();
    }
  });

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('.gummy-product-2011__form');
    if (!form) return;
    event.preventDefault();
    var submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function() {
        gummyOpenCartDrawer();
        var closePanel = form.querySelector('[data-gummy-customizer]');
        if (closePanel) closePanel.hidden = true;
        var closeSectionEl = form.closest('[data-gummy-product-section]');
        var closeScrimEl = closeSectionEl && closeSectionEl.querySelector('[data-gummy-customizer-scrim]');
        if (closeScrimEl) closeScrimEl.hidden = true;
        document.body.classList.remove('gummy-customizer-open');
        var openButton = form.querySelector('[data-gummy-customize-open]');
        if (openButton) openButton.setAttribute('aria-expanded', 'false');
      })
      .catch(function() {
        form.submit();
      })
      .finally(function() {
        if (submitButton) submitButton.disabled = false;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gummy-redirect"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gummy-redirect-to]').forEach(function(node) {
    var target = node.getAttribute('data-gummy-redirect-to');
    if (target) window.location.replace(target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
